
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Nur scrollen, wenn KEIN Hash vorhanden ist
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // Wenn ein Hash vorhanden ist, nicht scrollen (damit Tab-Links funktionieren)
  }, [pathname]);

  return null;
}
